module.exports = __webpack_public_path__ + "img/Edit.9282e009.svg";